<template>
	<div id="app">
		<!-- 当不需要布局时，只显示路由视图 -->
		<template v-if="$route.meta.noLayout">
			<router-view class="full-page-view"></router-view>
		</template>

		<!-- 默认布局 -->
		<el-container v-else class="app-container">
			<el-aside width="200px">
				<AppSidebar />
			</el-aside>
			<el-container class="main-background">
				<el-header style="padding: 0;">
					<AppHeader />
				</el-header>
				<el-main>
					<router-view class="main-box" :class="$route.meta.mainBoxClass || 'default-layout'"></router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import AppHeader from './components/AppHeader.vue';
	import AppSidebar from './components/AppSidebar.vue';

	export default {
		name: 'App',
		components: {
			AppHeader,
			AppSidebar,
		},
		watch: {
			'$route'() {
				document.title = this.$route.meta.title || '福斯华服务平台'
			}
		},
		mounted() {
			document.title = '福斯华服务平台'
			console.log(`
        _ooOoo_
       o8888888o
       88" . "88
       (| -_- |)
        O\\ = /O
     ___/'---'\\___
    .' \\\\|   |// '.
   / \\\\||| : |||// \\\\
 / _||||| -:- |||||- \\\\
   | | \\\\\\ - /// | |
   | \\_| ''\\---/'' |_/ |
    \\ .-\\__ '-' ___/-. /
  ___'..' /--.--\\ '..' ___
"" '< '.___\\_<|>_/___.' >' ""
     "" '.___ \\__/ ___.' '""
         '--'\\____/'--'
       佛祖保佑   永无BUG
    `);
		}
	};
</script>

<style>
	.full-page-view {
		width: 100%;
		height: 100vh;
		margin: 0;
		padding: 0;
		background: #fff;
	}
</style>

<style>
	@import url("assets/iconfont.css/iconfont.css");

	.app-container {
		height: 100vh;
		padding: 0px;
		margin: 0px;
		overflow: hidden;
	}

	body {
		padding: 0px;
		margin: 0px;
	}

	/* 设置滚动条的整体样式 */
	::-webkit-scrollbar {
		width: 3px;
		/* 滚动条宽度 */
		height: 3px;
		/* 滚动条高度（横向滚动条） */
	}

	/* 设置滚动条轨道 */
	::-webkit-scrollbar-track {
		background: #f1f1f1;
		/* 轨道背景色 */
		border-radius: 3px;
		/* 圆角 */
	}

	/* 设置滚动条滑块 */
	::-webkit-scrollbar-thumb {
		background: #888;
		/* 滑块颜色 */
		border-radius: 3px;
		/* 圆角 */
	}

	/* 设置滚动条滑块悬停效果 */
	::-webkit-scrollbar-thumb:hover {
		background: #555;
		/* 滑块悬停颜色 */
	}

	/* 隐藏滚动条箭头 */
	::-webkit-scrollbar-button {
		display: none;
		/* 隐藏上下箭头 */
	}

	.main-box {
		/* overflow-y: scroll; */
		width: 100%;

		margin: 0 auto;
		margin-top: 20px;
		border-radius: 10px;
		height: calc(100% - 20px);

	}

	.main-box.default-layout {
		background-color: #fff;
		box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, .1);
	}

	.main-box.special-layout {}

	.main-background {
		background-color: #ECEBEB;
	}
</style>